import { getAxios } from '../../lib/projectAxios'
import uuid from 'uuid/v4'
const axios = getAxios()
import { fromJS, Map, List, isImmutable } from 'immutable'
import { getParams, getState } from '../../lib/processPortalRules'
import _ from 'lodash'
import { getElemName } from '../../lib/common'
import { getPageUID } from '../../lib/getValueByType'
import { getProjectMappingElements, getProjectMappingPushElems } from '../../lib/project'
import { collectAllChildren } from '../../lib/widgets'
import { getMappingCount } from '../../constants/getMappingCount'
import { ELEM_TYPES } from '../../lib/constants/ElementTypes'

// ELEM_TYPES.TYPOGRAPHY && value !== undefined case for dynamic values, store value if the text is changes.
const shouldIncludeValueInSubmission = (rowValue, sett, rowType, value) => {
  return !isInternalSubmissionVariable(rowValue, sett) &&
    (rowType !== ELEM_TYPES.TYPOGRAPHY || rowType === ELEM_TYPES.TYPOGRAPHY && value !== undefined)
}

const getContentTypeByFile = function (fileName) {
  var rc = 'application/octet-stream'
  var fileNameLowerCase = String(fileName).toLowerCase()

  if (fileNameLowerCase.indexOf('.html') >= 0) rc = 'text/html'
  else if (fileNameLowerCase.indexOf('.css') >= 0) rc = 'text/css'
  else if (fileNameLowerCase.indexOf('.pdf') >= 0) rc = 'application/pdf'
  else if (fileNameLowerCase.indexOf('.docx') >= 0)
    rc = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  else if (fileNameLowerCase.indexOf('.json') >= 0) rc = 'application/json'
  else if (fileNameLowerCase.indexOf('.js') >= 0) rc = 'application/x-javascript'
  else if (fileNameLowerCase.indexOf('.txt') >= 0) rc = 'text/plain'
  else if (fileNameLowerCase.indexOf('.png') >= 0) rc = 'image/png'
  else if (fileNameLowerCase.indexOf('.jpg') >= 0) rc = 'image/jpeg'
  else if (fileNameLowerCase.indexOf('.jpeg') >= 0) rc = 'image/jpeg'
  else if (fileNameLowerCase.indexOf('.gif') >= 0) rc = 'image/gif'
  else if (fileNameLowerCase.indexOf('.tiff') >= 0) rc = 'image/tiff'
  else if (fileNameLowerCase.indexOf('.avi') >= 0) rc = 'video/avi'
  else if (fileNameLowerCase.indexOf('.mp4') >= 0) rc = 'video/mp4'
  else if (fileNameLowerCase.indexOf('.mp4v') >= 0) rc = 'video/mp4'
  else if (fileNameLowerCase.indexOf('.m4a') >= 0) rc = 'video/m4a'
  else if (fileNameLowerCase.indexOf('.m4v') >= 0) rc = 'video/m4v'
  else if (fileNameLowerCase.indexOf('.mov') >= 0) rc = 'video/quicktime'
  else if (fileNameLowerCase.indexOf('.svg') >= 0) rc = 'image/svg+xml'
  else if (fileNameLowerCase.indexOf('.3g2') >= 0) rc = 'video/3gpp2'
  else if (fileNameLowerCase.indexOf('.3gp') >= 0) rc = 'video/3gpp'
  else if (fileNameLowerCase.indexOf('.3gp2') >= 0) rc = 'video/3gpp2'
  else if (fileNameLowerCase.indexOf('.3gpp') >= 0) rc = 'video/3gpp'
  return rc
}

const isInternalSubmissionVariable = (key, nodeSettings) => {
  const submissionIdVariable = nodeSettings?.storeSubmissionID?.value
  const submissionJsonVariable = nodeSettings?.storeSubmissionJSON?.value

  return [submissionIdVariable, submissionJsonVariable].includes(key)
}

export const dataURLtoFile = (fileData, filename) => {
  const bstr = atob(fileData)
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n) {
    u8arr[n - 1] = bstr.charCodeAt(n - 1)
    n -= 1 // to make eslint happy
  }
  let blob = new Blob([u8arr])
  blob.lastModifiedDate = new Date()
  return new File([blob], filename, {
    type: getContentTypeByFile(filename),
  })
}

export const processSubmissionFlowNode = async (node, getAppState, dispatch, isCollectData) => {
  try {
    let sett = _.get(node, ['data', 'Submissions', 0])
    let state = getAppState()
    const elements = getProjectMappingElements(state, true)
    const mappingElements = getProjectMappingPushElems(state)
    const RepeatedStripsID = state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
    let params = getParams(state)
    let portalState = _.assign({}, params, getState(state))

    if (
      ((!sett || !sett.mapping) && sett.action === 'load') ||
      ((!sett || !sett.mapping) && sett.action === 'update')
    ) {
      return {
        status: false,
      }
    }

    let submissionData = {
      action: sett.action,
    }
    let submissionFiles = {}
    if (!_.isEmpty(sett.mapping) && _.isObject(sett.mapping)) {
      sett.mapping = _.reduce(
        sett.mapping,
        (r, v, k) => {
          if (v?.paramName) {
            v.paramName = _.trim(v.paramName)
          }
          return {
            ...r,
            [k]: v,
          }
        },
        {}
      )
    }

    let listForMap
    if (sett.action === 'store' || sett.action === 'update') {
      listForMap = elements
    } else {
      listForMap = mappingElements
    }

    if (sett.action === 'store' || sett.action === 'update') {
      let data = {}

      let parentList = []
      let pageUID = getPageUID(state.getIn(['page']), state.getIn(['project', 'Pages'], List()))
      switch (sett.storeListType) {
        case 'onPage':
          parentList = _.filter(listForMap, (row) => {
            if (
              row &&
              (String(row.value).startsWith(`${pageUID}:`) || row.group === 'param' || row.group === 'pageParam')
            ) {
              return true
            }
          })
          break
        case 'onField':
          parentList = _.filter(listForMap, (row) => {
            if (row && row.value == sett.fieldItem) {
              return true
            }
          })
          break
        case 'fromStrip':
          const [pageID, stripId] = String(sett.fromStripId).split(':')
          const children = state.getIn(['pages', pageID, 'Props', 'elements', stripId, 'children'], List()).toJS()
          const allChildID = collectAllChildren(children, ['pages', pageID, 'Props'], state)
          const isInclude = (list1, list2) =>
            _.filter(list1, (v) => list2.includes(v) || list2.includes(_.first(String(v).split('-')))).length > 0
          parentList = _.filter(listForMap, (row) => {
            if (row && isInclude(String(row.value).split(':'), allChildID)) {
              return true
            }
          })
          break
        case 'onFieldGroup':
          parentList = _.filter(listForMap, (row) => {
            if (row && sett.fieldGroup && _.includes(sett.fieldGroup, row.value)) {
              return true
            }
          })
          break
      }

      let keyHash = {}
      _.each(parentList, (row) => {
        if (!row.uid) {
          let path = String(row.value).split(':')
          if (RepeatedStripsID.includes(path[1])) {
            row.uid = path[2]
          } else {
            row.uid = path[1]
          }
        }
        let key = _.get(sett.mapping, [row.value, 'paramName'])
        if (!key) {
          key = _.deburr(row.label)
          keyHash[key] = keyHash[key] || 0
          keyHash[key]++
          if (keyHash[key] > 1) {
            key += `_${row.uid}`
          }
        } else {
          key = _.deburr(row.label)
          keyHash[key] = keyHash[key] || 0
          keyHash[key]++
          if (keyHash[key] > 1) {
            key += `_${row.uid}`
          }
        }
        let elem = state.hasIn(['project', 'Settings', 'elements', row.uid, 'type'])
          ? state.getIn(['project', 'Settings', 'elements', row.uid], Map())
          : state.getIn(['pages', state.get('page'), 'Props', 'elements', row.uid], Map())
        let elPath = String(row.value).split(':')
        let count = getMappingCount(_.get(portalState, _.slice(String(row.value).split(':'), 0, 2)))
        if (
          Map.isMap(elem) &&
          elem.getIn(['props', 'control']) === 'fileupload' &&
          (_.endsWith(row.value, row.uid) || _.endsWith(row.value, `${row.uid}:ft_fileupload`))
        ) {
          if (RepeatedStripsID.includes(elPath[1])) {
            _.times(count, (n) => {
              submissionFiles[`${key}_${n}`] = submissionFiles[`${key}_${n}`] || []
              submissionFiles[`${key}_${n}`].push(
                _.get(window, ['__FT_PROJECT__API__FILES__', 'files', row.uid, n, 'files'], []) || []
              )
            })
          } else {
            submissionFiles[key] = submissionFiles[key] || []
            submissionFiles[key] = _.get(window, ['__FT_PROJECT__API__FILES__', 'files', row.uid, 'files'], []) || []
          }
        }
        if (typeof data[key] === 'undefined') {
          if (RepeatedStripsID.includes(elPath[1])) {
            if (
              elem.getIn(['props', 'control']) === 'fileupload' &&
              (_.endsWith(row.value, row.uid) || _.endsWith(row.value, `${row.uid}:ft_fileupload`))
            ) {
              let path = elPath
              let values = []
              _.times(count, (n) => {
                if (path.includes('ft_fileupload')) {
                  values.push(_.get(portalState, [..._.initial(path), n, 'ft_fileupload']))
                } else {
                  values.push(_.get(portalState, [...path, n, 'ft_fileupload']))
                }
              })
              data[key] = values
            } else {
              const value = _.get(portalState, String(row.value).split(':'))

              if (shouldIncludeValueInSubmission(row.value, sett, row.type, value)) {
                data[key] = value
              }

              if (_.isNil(value) && Map.isMap(elem) && elem.size > 0) {
                if (
                  elem.get('type') === 'CircleSlider' ||
                  ['radio', 'lookup', 'daterange'].includes(elem.getIn(['props', 'control']))
                ) {
                  let path = _.initial(elPath)
                  let prop = _.last(elPath)
                  let values = []
                  _.times(count, (n) => {
                    values.push(_.get(portalState, [...path, n, prop]))
                  })
                  data[key] = values
                }
              }
            }
          } else {
            if (
              elem.getIn(['props', 'control']) === 'fileupload' &&
              (_.endsWith(row.value, row.uid) || _.endsWith(row.value, `${row.uid}:ft_fileupload`))
            ) {
              let value = _.endsWith(row.value, `${row.uid}:ft_fileupload`)
                ? _.get(portalState, String(row.value).split(':'))
                : _.get(portalState, [...String(row.value).split(':'), 'ft_fileupload'])
              if (value !== undefined && value !== null) {
                data[key] = value
              }
            } else {
              const value = _.get(portalState, String(row.value).split(':'))

              if (shouldIncludeValueInSubmission(row.value, sett, row.type, value)) {
                data[key] = value
              }
            }
          }
        }
      })
      submissionData.data = data
    }
    if (['load', 'delete', 'update'].indexOf(sett.action) !== -1) {
      if (!sett.submissionID && !sett.bucketName) {
        return {
          status: false,
        }
      }
      let id, projectId
      if (_.get(sett, 'submissionID.type', 'static') == 'field') {
        if (sett.submissionID?.field) {
          if (String(sett.submissionID.field).indexOf(':') > -1) {
            id = _.get(portalState, String(sett.submissionID.field).split(':'))
          } else {
            id = _.get(params, sett.submissionID.field)
          }
        }
      } else {
        id = sett.bucketName
      }
      if (_.get(sett, 'projectId.type', 'static') == 'ftCurrProj') {
        projectId = state.getIn(['project', '_id'])
      } else if (_.get(sett, 'projectId.type', 'static') == 'field') {
        if (sett.projectId?.field) {
          if (String(sett.projectId.field).indexOf(':') > -1) {
            projectId = _.get(portalState, String(sett.projectId.field).split(':'))
          } else {
            projectId = _.get(params, sett.projectId.field)
          }
        }
      } else {
        projectId = sett.projectIdStatic
      }

      if (!id || !projectId) {
        return {
          status: false,
        }
      }
      submissionData.id = id
      submissionData.projectId = projectId
      if (sett.action === 'update') {
        submissionData.mapping = sett.mapping
      }
      if (sett.action === 'load') {
        submissionData.mapping = sett.mapping
        let parentList = []
        let pageUID = getPageUID(state.getIn(['page']), state.getIn(['project', 'Pages'], List()))
        switch (sett.storeListType) {
          case 'onPage':
            parentList = _.filter(listForMap, (row) => {
              if (
                row &&
                (String(row.value).startsWith(`${pageUID}:`) || row.group === 'param' || row.group === 'pageParam')
              ) {
                return true
              }
            })
            break
          case 'onField':
            parentList = _.filter(listForMap, (row) => {
              if (row && row.value == sett.fieldItem) {
                return true
              }
            })
            break
          case 'fromStrip':
            const [pageID, stripId] = String(sett.fromStripId).split(':')
            const children = state.getIn(['pages', pageID, 'Props', 'elements', stripId, 'children'], List()).toJS()
            const allChildID = collectAllChildren(children, ['pages', pageID, 'Props'], state)
            const isInclude = (list1, list2) =>
              _.filter(list1, (v) => list2.includes(v) || list2.includes(_.first(String(v).split('-')))).length > 0
            parentList = _.filter(listForMap, (row) => {
              if (row && isInclude(String(row.value).split(':'), allChildID)) {
                return true
              }
            })
            break
          case 'onFieldGroup':
            parentList = _.filter(listForMap, (row) => {
              if (row && sett.fieldGroup && _.includes(sett.fieldGroup, row.value)) {
                return true
              }
            })
            break
        }

        let keyHash = {}
        let RepeatedStripsID = state.getIn(['project', 'Settings', 'RepeatedStripsID'], List()).toJS()
        _.each(parentList, (row) => {
          if (!row.uid) {
            let path = String(row.value).split(':')
            if (RepeatedStripsID.includes(path[1])) {
              row.uid = path[2]
            } else {
              row.uid = path[1]
            }
          }
          if (!_.get(submissionData.mapping, [row.value, 'paramName'])) {
            let key = _.deburr(row.label)
            keyHash[key] = keyHash[key] || 0
            keyHash[key]++
            if (keyHash[key] > 1) {
              key += `_${row.uid}`
            }
            _.set(submissionData.mapping, [row.value, 'paramName'], key)
          }
        })
      }
    }
    // console.log('submissionData >>>', submissionData)

    if (isCollectData) {
      return {
        status: true,
        data: submissionData,
        files: submissionFiles,
      }
    }
    const recursiveProcessSubmissionFlow = async (attemp) => {
      if (attemp >= 3) {
        return {
          status: 200,
          data: {
            status: false,
          },
        }
      }
      try {
        let formData = new FormData()
        formData.append('useConnection', sett.useConnection)
        formData.append('connection', sett.connection)
        _.each(submissionFiles, (files, id) => {
          _.each(files, (file) => {
            if (Array.isArray(file)) {
              _.each(file, (fileItem) => {
                formData.append(id, fileItem, fileItem.name)
              })
            } else {
              formData.append(id, file, file.name)
            }
          })
        })
        if ((sett.action === 'store' || sett.action === 'update') && sett.isSkipEmptyVal) {
          submissionData.data = _.reduce(
            submissionData.data,
            (r, v, k) => ({
              ...r,
              ...(v !== '' && v !== null && v !== undefined ? { [k]: v } : {}),
            }),
            {}
          )
          if (_.isEmpty(submissionData.data)) {
            console.log('Submission has no data to perform %s action', sett.action)
            return {}
          }
        }
        if (sett.action === 'update' && sett.isUpdateOnlyChanged) {
          const id = submissionData.id
          const projectId = submissionData.projectId
          const loadedState = state.getIn(['_submission_cache_', projectId, id], Map())
          submissionData.data = _.reduce(
            submissionData.data,
            (r, v, k) => {
              let key = _.findKey(submissionData.mapping, (val) => val.paramName === k)
              return {
                ...r,
                ...(loadedState.get(key) !== v ? { [k]: v } : {}),
              }
            },
            {}
          )
          if (_.isEmpty(submissionData.data)) {
            console.log('Submission has no data changed to perform %s action', sett.action)
            return {}
          }
        }
        _.each(submissionData, (val, key) => {
          if (_.isObject(val)) {
            formData.append(
              key,
              JSON.stringify(val, (__, v) => (_.isUndefined(v) ? '' : v)) // convert undefined to empty string as JSON.stringify ignores undefined
            )
          } else {
            formData.append(key, val)
          }
        })
        let result = await axios.post('/webprojects/flow/submission', formData, {
          'Content-Type': 'multipart/form-data',
        })
        return result
      } catch (err) {
        console.log('err >>> ', err)
        await new Promise((resolve) => {
          setTimeout(resolve, 2 * 1000)
        })

        return recursiveProcessSubmissionFlow(attemp + 1)
      }
    }

    const { status, data } = await recursiveProcessSubmissionFlow(0)

    if (sett.action === 'store' || sett.action === 'update') {
      return _.assign(
        {
          data: submissionData.data,
        },
        data
      )
    }
    if (['load', 'delete', 'update'].indexOf(sett.action) !== -1) {
      let applyFiles = {}
      let keyIndex = {}
      const filesList = _.sortBy(
        _.reduce(data.files, (r, v, k) => [...r, { files: v, fileKey: k }], []),
        'fileKey'
      )
      _.each(filesList, ({ files, fileKey }) => {
        let key = String(fileKey).replace(/(_[0-9]*)$/gim, '')
        let mappingKey = _.findKey(
          submissionData.mapping,
          (val) => _.toLower(_.get(val, 'paramName')) === _.toLower(key)
        )
        if (!mappingKey) {
          let row = _.find(listForMap, (val) => {
            let path = String(val.value).split(':')
            if (RepeatedStripsID.includes(path[1])) {
              return `${val.label}_${path[2]}` === key
            } else {
              return `${val.label}_${path[1]}` === key
            }
          })
          if (row) {
            mappingKey = row.value
          }
        }
        let path = String(mappingKey).split(':')
        let wKey
        if (RepeatedStripsID.includes(path[1])) {
          let [rowIndex, fileIndex] = _.trim(String(fileKey).replace(key, ''), '_').split('_')
          wKey = ['files', path[2], rowIndex, 'files'].join(':')
          if (!applyFiles[wKey]) {
            applyFiles[wKey] = []
            let rowFKey = _.toLower(`${key}_${rowIndex}`)
            keyIndex[rowFKey] = keyIndex[rowFKey] ?? 0
            const filesList = _.sortBy(
              _.reduce(data.files, (r, v, k) => [...r, { file: v, fKey: k }], []),
              'fKey'
            )
            _.each(filesList, ({ file, fKey }) => {
              if (_.startsWith(_.toLower(fKey), rowFKey)) {
                let jsFile = dataURLtoFile(file, _.get(data, ['data', mappingKey, rowIndex, keyIndex[rowFKey]]))
                applyFiles[wKey] = applyFiles[wKey] || []
                applyFiles[wKey].push(jsFile)
                keyIndex[rowFKey] += 1
              }
            })
          }
        } else {
          if (_.last(path) === 'ft_fileupload') {
            wKey = ['files', path[path.length - 2], 'files'].join(':')
          } else {
            wKey = ['files', path[path.length - 1], 'files'].join(':')
          }
          _.each(files, (file, index) => {
            keyIndex[mappingKey] = keyIndex[mappingKey] ?? 0
            let jsFile = dataURLtoFile(file, _.get(data, ['data', mappingKey, keyIndex[mappingKey]]))
            applyFiles[wKey] = applyFiles[wKey] || []
            applyFiles[wKey].push(jsFile)
            keyIndex[mappingKey] += 1
          })
        }
      })
      window.__FT_PROJECT__API__FILES__ = window.__FT_PROJECT__API__FILES__ || {}
      _.each(applyFiles, (files, key) => {
        _.set(window.__FT_PROJECT__API__FILES__, key.split(':'), files)
      })
    }
    if (sett.action === 'load') {
      data.meta = {
        id: submissionData.id,
        projectId: submissionData.projectId,
      }
    }
    return data
  } catch (err) {
    console.error(err)
  }

  return {
    status: true,
  }
}
